import React from 'react';
import ApprovalItem from '../ApprovalItem';
import styles from './style.module.scss';

const DeclinedTab = ({ items, isExpanded, appData }) => {
  return (
    <div className={styles.tabContent}>
      {items.length > 0 ? (
        <div className={`${styles.itemsList} ${isExpanded ? styles.expanded : ''}`}>
          {items.map(item => (
            <ApprovalItem 
              key={item.id} 
              item={item}
              showStatus
              showApprover
              appData={appData}
            />
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>No declined items to display</div>
      )}
    </div>
  );
};

export default DeclinedTab;